import {
  httpRequest,
  querystringBuilderByObject
} from '@common/util/api-common.util';

export default class DescarteApi {

  static getItemsDescartados(id){
    return httpRequest(`descarteMaterial/itemsDescartados/${id}`).then(json => json.data);
  }

  static restaurarItemsDescartados(id, payload){
    return httpRequest(`descarteMaterial/removerItem/${id}`, 'DELETE', payload);
  }

  static getItensRelatorio (
    tipo,
    filtroTipoValue,
    filtroValue,
    dataInicio,
    dataFim
  ) {
    const obj = filtroTipoValue.includes('dt')
      ? { filtroTipoValue, dataInicio, dataFim }
      : { filtroTipoValue, filtroValue };

    const query = querystringBuilderByObject(obj);

    return httpRequest(`descartematerial/relatorio/${tipo}${query}`).then(
      json => json.data
    );
  }

  static listarDescarte (
    filtroTipoValue,
    filtroValue,
    dataInicio,
    dataFim, 
    numPagina, 
    tamanhoPagina,
    filtroTipo, 
    sortName,
    sortAsc
  ) {
    let obj;
    if(filtroTipoValue.includes('dt')){
      obj = sortName ? { filtroTipoValue, dataInicio, dataFim, numPagina, tamanhoPagina, filtroTipo, sortName, sortAsc }
      : { filtroTipoValue, dataInicio, dataFim, numPagina, tamanhoPagina, filtroTipo }
    }else{
      obj = sortName ? { filtroTipoValue, filtroValue, numPagina, tamanhoPagina, filtroTipo, sortName, sortAsc } 
      : { filtroTipoValue, filtroValue, numPagina, tamanhoPagina, filtroTipo } 
    }

    const query = querystringBuilderByObject(obj);

    return httpRequest(`descartematerial/materiaisdescarte${query}`);
  }

  static restaurar (payload) {
    return httpRequest('descarteMaterial', 'DELETE', payload);
  }

  static descartar (payload) {
    return httpRequest('descarteMaterial', 'POST', payload);
  }

  static listarLote (
    filtroTipoValue,
    filtroValue,
    dataInicio,
    dataFim, 
    numPagina, 
    tamanhoPagina,
    filtroTipo, 
    sortName,
    sortAsc
  ) {
    let obj;
    if(filtroTipoValue.includes('dt')){
      obj = sortName ? { filtroTipoValue, dataInicio, dataFim, numPagina, tamanhoPagina, filtroTipo, sortName, sortAsc }
      : { filtroTipoValue, dataInicio, dataFim, numPagina, tamanhoPagina, filtroTipo }
    }else{
      obj = sortName ? { filtroTipoValue, filtroValue, numPagina, tamanhoPagina, filtroTipo, sortName, sortAsc } 
      : { filtroTipoValue, filtroValue, numPagina, tamanhoPagina, filtroTipo } 
    }

    const query = querystringBuilderByObject(obj);

    return httpRequest(`descartematerial/lotesDescartados${query}`);
  }

  static listarMotivosDescarte () {
    return httpRequest(`descartematerial/motivosDescarte`);
  }

  static totalItemsDescarte () {
    return httpRequest(`descarteMaterial`).then(json => json.data);
  }

  static atualizarPeso (id, peso) {
    const payload = {
      idMaterial: id,
      peso
    }
    return httpRequest('descarteMaterial/updatepesomaterial', 'PATCH', payload);
  }

  static atualizarIdicacao (id, indicacao) {
    const payload = {
      idMaterial: id,
      indicacao
    }
    return httpRequest('descarteMaterial/updateindicacaomaterial', 'PATCH', payload);
  }
}



// WEBPACK FOOTER //
// ./src/pages/descarte/descarte.api.js